:global(html, body) {
    margin: 0;
    padding: 0;
}

.container {
    overflow-x: clip;
}
